/**
 * Default Skribble values for the seven brand-configurable design tokens.
 * When the public-information endpoint returns a theme, provided fields
 * override these; missing fields fall back here.
 */
export const DEFAULT_IDENTIFICATION_THEME: ResolvedIdentificationTheme = {
  typography: {
    headingFontFamily: 'inherit',
    bodyFontFamily: 'inherit',
  },
  branding: {
    faviconUrl: '',
    spinner: 'primary',
    pageTitle: 'Skribble',
    helpCenterUrl: '',
  },
}
